var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAvailableAdresses = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 73,
    viewBox: "0 0 82 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 -11C4.70101 -11 0 -6.29898 0 -0.499992V58.2288C0 64.0278 4.70102 68.7288 10.5 68.7288H37.6291C32.8423 63.7405 29.9004 56.9682 29.9004 49.5088C29.9004 34.1759 42.3302 21.7461 57.6631 21.7461C66.659 21.7461 74.6555 26.0247 79.7288 32.6579V-0.5C79.7288 -6.29899 75.0278 -11 69.2288 -11H10.5Z",
    fill: "#FFE0A3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.6614,
    cy: 49.5081,
    r: 23.4915,
    fill: "#FFAB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9492 36.6963V49.5098H68.339",
    stroke: "#FFE6B4",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5078 3.2373H63.3553",
    stroke: "#FFAB00",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5078 17.4746H63.3553",
    stroke: "#FFAB00",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5078 31.7129H31.3214",
    stroke: "#FFAB00",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5078 45.9502H25.6265",
    stroke: "#FFAB00",
    strokeWidth: 6,
    strokeLinecap: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAvailableAdresses);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/available_adresses.2dae5c3c97da455ed308cfee9b6f526d.svg";